webpackJsonp([2],{

/***/ 54:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 63:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_order_css__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assets_order_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__assets_order_css__);


/***/ })

},[63]);


// WEBPACK FOOTER //
// static/js/appcss.6ff7c27d56b353651954.js